import { useMemo } from "react";
import {
    List,
    Datagrid,
    TextField,
    NumberField,
    DateField,
    ShowButton,
    DeleteButton,
    Filter,
    NumberInput,
    DateInput,
    TextInput,
    downloadCSV,
    FunctionField,
    useListContext,
    usePermissions,   // ✅ ADD THIS
} from "react-admin";
import jsonExport from "jsonexport/dist";
import { Typography, Box } from "@mui/material";



// ✅ EXPORTER (unchanged)
const exporter = (records) => {
    console.log("EXPORT RECORDS:", records);

    const exportData = records.map(record => {
        const transformed = {
            id: record.id,
            form: record.form_title,
            type: record.feedback_type_name,
            email: record.email,
            submitted_at: record.submitted_at,
        };

        if (record.labeled_answers) {
            record.labeled_answers.forEach(answer => {
                transformed[answer.question] = Array.isArray(answer.answer)
                    ? answer.answer.join(", ")
                    : answer.answer;
            });
        }

        return transformed;
    });

    jsonExport(exportData, (err, csv) => {
        downloadCSV(csv, "feedback-submissions");
    });
};


// FILTERS
const SubmissionFilter = (props) => (
    <Filter {...props}>
        <NumberInput label="Feedback Type ID" source="feedback_type_id" />
        <TextInput label="Email" source="email" />
        <DateInput label="From Date" source="submitted_at_gte" />
        <DateInput label="To Date" source="submitted_at_lte" />
    </Filter>
);


const FeedbackSubmissionGrid = () => {
  const { data, isLoading } = useListContext();
  const { permissions = [] } = usePermissions();   // ✅ GET USER PERMISSIONS

  // ✅ Permission checks
  const canShow =
    permissions.includes("forms.read") ||
    permissions.includes("forms.*") ||
    permissions.includes("*");

  const canDelete =
    permissions.includes("forms.delete") ||
    permissions.includes("forms.*") ||
    permissions.includes("*");

  // Memoize questions
  const questions = useMemo(() => {
    if (!data?.length) return [];

    const firstRecord = data[0];

    return [
      ...new Map(
        (firstRecord.labeled_answers || [])
          .filter((answer) => answer.add_to_table)
          .map((a) => [a.question.trim(), a])
      ).values(),
    ];
  }, [data]);

  if (isLoading) return null;

  return (
    <>
      
      {/* ✅ SAME UI AS FORMTYPE */}
      <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          Responses
        </Typography>
      </Box>


    <Datagrid rowClick={canShow ? "show" : false}>   {/*  CONTROL ROW CLICK */}
      <NumberField source="id" />
      <TextField source="email" />

      {questions.map((q, index) => (
        <FunctionField
          key={`q-${index}`}
          label={q.label || q.question}
          render={(record) => {
            const found = record.labeled_answers?.find(
              (a) => a.question.trim() === q.question.trim()
            );

            if (!found) return "";

            return Array.isArray(found.answer)
              ? found.answer.join(", ")
              : String(found.answer);
          }}
        />
      ))}

      {/*  CONDITIONAL BUTTONS */}
      {canShow && <ShowButton />}
      {canDelete && <DeleteButton />}
    </Datagrid>
    </>
   
  );
};



//  MAIN LIST
export const FeedbackSubmissionList = () => (
    <List
    
        filters={<SubmissionFilter />}
        perPage={25}
        exporter={exporter}
    >
        <FeedbackSubmissionGrid />
    </List>
);